/**
 * TCG configuration
 * This file contains constants and configuration for all supported TCGs
 */

import { MTG_FORMATS } from './index';
import { POKEMON_TYPES, POKEMON_RARITIES, POKEMON_SUPERTYPES, POKEMON_SUBTYPES, POKEMON_CONDITIONS, POKEMON_LANGUAGES, POKEMON_FINISHES, POKEMON_EDITIONS } from './pokemon';

// Supported TCGs
export const SUPPORTED_TCGS = [
  { 
    id: 'mtg', 
    name: 'Magic: The Gathering',
    shortName: 'MTG',
    apiType: 'scryfall',
    enabled: true,
    icon: '/icons/mtg-icon.svg', // You'll need to create these icons
    primaryColor: '#26586c',
    secondaryColor: '#bf4427',
  },
  { 
    id: 'pokemon', 
    name: 'Pokémon',
    shortName: 'Pokémon',
    apiType: 'pokemontcg',
    enabled: true,
    icon: '/icons/pokemon-icon.svg',
    primaryColor: '#ffcb05',
    secondaryColor: '#3c5aa6',
  },
  // Future TCGs can be added here
  { 
    id: 'yugioh', 
    name: 'Yu-Gi-Oh!',
    shortName: 'YGO',
    apiType: 'yugioh',
    enabled: false, // Not yet implemented
    icon: '/icons/yugioh-icon.svg',
    primaryColor: '#7d57c1',
    secondaryColor: '#f2a341',
  },
];

// Get the default TCG
export const getDefaultTCG = () => {
  return SUPPORTED_TCGS.find(tcg => tcg.enabled) || SUPPORTED_TCGS[0];
};

// Get enabled TCGs
export const getEnabledTCGs = () => {
  return SUPPORTED_TCGS.filter(tcg => tcg.enabled);
};

// TCG-specific configurations
export const TCG_CONFIG = {
  mtg: {
    formats: MTG_FORMATS,
    conditions: [
      { id: 'NM', name: 'Near Mint' },
      { id: 'LP', name: 'Lightly Played' },
      { id: 'MP', name: 'Moderately Played' },
      { id: 'HP', name: 'Heavily Played' },
      { id: 'DMG', name: 'Damaged' },
    ],
    languages: [
      { id: 'English', name: 'English' },
      { id: 'Japanese', name: 'Japanese' },
      { id: 'German', name: 'German' },
      { id: 'French', name: 'French' },
      { id: 'Italian', name: 'Italian' },
      { id: 'Spanish', name: 'Spanish' },
      { id: 'Portuguese', name: 'Portuguese' },
      { id: 'Russian', name: 'Russian' },
      { id: 'Korean', name: 'Korean' },
      { id: 'Chinese Simplified', name: 'Chinese Simplified' },
      { id: 'Chinese Traditional', name: 'Chinese Traditional' },
    ],
    finishes: [
      { id: 'Non-Foil', name: 'Non-Foil' },
      { id: 'Foil', name: 'Foil' },
      { id: 'Etched', name: 'Etched Foil' },
      { id: 'Glossy', name: 'Glossy' },
    ],
    apiBaseUrl: 'https://api.scryfall.com',
    imageBaseUrl: 'https://cards.scryfall.io',
  },
  pokemon: {
    types: POKEMON_TYPES,
    rarities: POKEMON_RARITIES,
    supertypes: POKEMON_SUPERTYPES,
    subtypes: POKEMON_SUBTYPES,
    conditions: POKEMON_CONDITIONS,
    languages: POKEMON_LANGUAGES,
    finishes: POKEMON_FINISHES,
    editions: POKEMON_EDITIONS,
    apiBaseUrl: 'https://api.pokemontcg.io/v2',
    imageBaseUrl: 'https://images.pokemontcg.io',
  },
};

// Get configuration for a specific TCG
export const getTCGConfig = (tcgId) => {
  return TCG_CONFIG[tcgId] || TCG_CONFIG.mtg;
};

// Get conditions for a specific TCG
export const getConditionsForTCG = (tcgId) => {
  return getTCGConfig(tcgId).conditions || [];
};

// Get languages for a specific TCG
export const getLanguagesForTCG = (tcgId) => {
  return getTCGConfig(tcgId).languages || [];
};

// Get finishes for a specific TCG
export const getFinishesForTCG = (tcgId) => {
  return getTCGConfig(tcgId).finishes || [];
};
